export default {
  getPromotions: (state) => {
    return state.promotions;
  },
  getProducts: (state) => {
    return state.products;
  },
};
